// Durée d'une séance.
//
// Dérivée de started_at et ended_at plutôt que stockée : le joueur peut
// corriger l'heure de début après coup, et une durée figée deviendrait alors
// fausse sans que rien ne le signale. Ce qui est conservé, ce sont les deux
// bornes — la durée s'en déduit toujours.

/** Millisecondes écoulées, ou null si la séance n'a pas de fin connue. */
export function durationMs(startedAt: string, endedAt: string | null): number | null {
    if (!endedAt) return null;
    const ms = new Date(endedAt).getTime() - new Date(startedAt).getTime();
    return ms >= 0 ? ms : null;
}

/** « 1 h 05 », « 42 min », « moins d'une minute ».
 *
 *  Pas de secondes : une séance de practice se compte en minutes, et un
 *  compteur à la seconde donnerait une précision que la mesure n'a pas — le
 *  joueur arrête souvent la séance en rangeant ses clubs. */
export function formatDuration(ms: number): string {
    const totalMinutes = Math.round(ms / 60_000);
    if (totalMinutes < 1) return "moins d'une minute";
    if (totalMinutes < 60) return `${totalMinutes} min`;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes === 0 ? `${hours} h` : `${hours} h ${String(minutes).padStart(2, '0')}`;
}

/** La même durée, en tenant dans une colonne étroite : « 1h05 », « 42 min »,
 *  « 0 min ».
 *
 *  « moins d'une minute » est juste et lisible dans une phrase, mais se faisait
 *  tronquer en « moins d'… » dans le bandeau de l'écran de saisie — où la
 *  colonne fait un quart de la largeur d'un téléphone. Un chiffre y tient
 *  toujours, et se lit plus vite qu'une locution. */
export function formatDurationShort(ms: number): string {
    const totalMinutes = Math.max(0, Math.round(ms / 60_000));
    if (totalMinutes < 60) return `${totalMinutes} min`;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes === 0 ? `${hours} h` : `${hours}h${String(minutes).padStart(2, '0')}`;
}

/** Durée d'une séance terminée, prête à afficher. */
export function sessionDuration(startedAt: string, endedAt: string | null): string | null {
    const ms = durationMs(startedAt, endedAt);
    return ms == null ? null : formatDuration(ms);
}
